import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldAlert, Wrench } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const fmt = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n || 0);

// Shown under the Opening Balance card when stored "settled" ≠ live receipts (deleted receipts still counted, etc.)
export const OpeningRepairBanner = ({ ledger, clientId, canEdit, onRepaired }) => {
  const [busy, setBusy] = useState(false);
  const a = ledger?.opening_audit;
  if (!a?.needs_repair) return null;
  const repair = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/vouchers/integrity/repair-opening`, { client_id: clientId }, { withCredentials: true });
      const res = r.data.results?.[0] || {};
      toast.success(`Opening balance repaired · settled ${fmt(res.settled_before)} → ${fmt(res.settled_after)}`);
      onRepaired?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Repair failed'); }
    finally { setBusy(false); }
  };
  return (
    <div className="px-4 pt-2" data-testid="opening-repair-banner">
      <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-3 flex items-start gap-2">
        <ShieldAlert size={14} className="text-red-400 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0 text-[11px] text-zinc-300">
          <div className="text-red-300 font-semibold text-xs">Opening balance out of sync with receipts</div>
          {a.orphans?.length > 0 && <div>{a.orphans.length} deleted receipt(s) still reduce the opening due by {fmt(a.orphan_total)}.</div>}
          {a.unrepresented?.length > 0 && <div>{a.unrepresented.length} receipt(s) against the B/F are not sliced ({a.unrepresented.map(u => u.voucher_number).join(', ')}) · {fmt(a.unrepresented_total)}.</div>}
          <div className="text-zinc-500">Stored settled {fmt(a.scalar)} · live receipts {fmt(a.valid_total)} — Repair makes every screen use the live figure.</div>
        </div>
        {canEdit && (
          <button onClick={repair} disabled={busy} data-testid="opening-repair-btn"
            className="flex items-center gap-1 text-[11px] bg-amber-500 hover:bg-amber-400 text-black font-semibold px-2.5 py-1.5 rounded-lg disabled:opacity-50 shrink-0">
            <Wrench size={12} /> Repair
          </button>
        )}
      </div>
    </div>
  );
};
